import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_MERGE_OBJECTS_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_MERGE_OBJECTS_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/MergeObjectsModal')
};